<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row>
      <b-col>
        <b-row>
          <b-col cols="0" class="ml-4">
            <b-button size="sm" @click="showModal()">
              {{ $t("workflow.create") }}
            </b-button>
          </b-col>
          <b-col cols="0" class="ml-2">
            <router-link :to="`/workflow/filled/import/${name}/${id}`">
              <b-button size="sm">
                {{ $t("geral.import") }}
              </b-button>
            </router-link>
            <!-- <b-button size="sm" @click="showImportModal()">
              {{ $t("geral.import") }}
            </b-button> -->
          </b-col>
          <b-col cols="0" class="ml-2">
            <b-button size="sm" @click="layoutModal()">
              {{ $t("workflow.kanban.importLayout") }}
            </b-button>
          </b-col>
          <b-col cols="0" class="ml-2">
            <b-button size="sm" @click="refreshTowers()">
              {{ $t("geral.refresh") }}
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          :label="$t('geral.search')"
          label-for="input-search-query"
          label-align="right"
        >
          <b-input-group
            label-cols="4"
            label-cols-lg="2"
            :label="$t('geral.search')"
            label-for="input-search-query"
            label-align="right"
          >
            <b-form-input
              type="text"
              id="input-search-query"
              :placeholder="$t('geral.searchPlaceholder')"
              v-model="searchQuery"
              debounce="2000"
              v-on:update="onChangeSearchQuery()"
            >
            </b-form-input>
            <b-input-group-append>
              <b-button
                type="button"
                @click.prevent="onChangeSearchQuery()"
                size="sm"
              >
                <span
                  class="icon"
                  style="font-family: Helvetica, Arial, sans-serif"
                >
                  <i class="tim-icons icon-zoom-split"> </i>
                  <!-- <i class="el-icon-search"> </i> -->
                </span>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- <workflow-board :items="towers" @refreshData="fetchEventsList">
    </workflow-board> -->

    <kanban-board id="kanban-board">
      <kanban-tower v-for="tower in towers" :key="tower.name">
        <kanban-task-lane-infinite-scroll
          ref="taskLane"
          :tower="tower"
          @countItems="taskLaneCount"
          @getItems="taskLaneProvider"
        >
          <template v-slot:task-lane-item="{ item }">
            <kanban-task-lane-item :item="item">
              <!-- <template v-slot:card="{ item }">
                <workflow-kanban-card :item="item" :tower="tower">
                </workflow-kanban-card>
              </template> -->
              <template v-slot:card="{ item }">
                <workflow-kanban-card :item="item" :tower="tower">
                  <template v-slot:card-buttons="{ item }">
                    <div class="mt-2">
                      <workflow-kanban-card-actions
                        :id="item.id"
                        :stageId="item.stageId"
                        :model="item"
                        :tower="tower"
                        :permission="getPermissions(tower)"
                        @refreshData="autoRefreshTowers"
                      >
                      </workflow-kanban-card-actions>
                    </div>
                  </template>
                </workflow-kanban-card>
              </template>
            </kanban-task-lane-item>
          </template>
        </kanban-task-lane-infinite-scroll>
      </kanban-tower>
    </kanban-board>

    <!-- criar novo processo -->
    <workflow-fill-modal
      ref="fillModal"
      :id="id"
      @refreshData="autoRefreshTowers"
    >
    </workflow-fill-modal>

    <!-- importar processo -->
    <!-- <workflow-import-modal ref="importModal" :processId="id" @refreshData="autoRefreshTowers"></workflow-import-modal> -->

    <!-- laout de importação -->
    <workflow-import-layout-modal
      ref="layoutImport"
      :processId="id"
    ></workflow-import-layout-modal>

    <!-- {{towers}} -->
    <!-- <pre class="language-json"><code>towers: {{ model  }}</code></pre> -->
  </div>
</template>
<script>
export default {
  name: "WorkflowTower",
  props: {
    id: String,
    name: String,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    // WorkflowBoard: () =>
    //   import("@/components_rms/workflow/Kanban/WorkflowKanban.vue"),
    WorkflowFillModal: () =>
      import("@/components_rms/workflow/WorkflowFillModal.vue"),
    // WorkflowImportModal: () =>
    //   import("@/components_rms/workflow/WorkflowImportModal.vue"),
    WorkflowImportLayoutModal: () =>
      import("@/components_rms/workflow/WorkflowImportLayoutModal.vue"),

    KanbanBoard: () =>
      import("@/components_rms/kanban_infinite_scroll/KanbanBoard.vue"),
    KanbanTaskLaneInfiniteScroll: () =>
      import(
        "@/components_rms/kanban_infinite_scroll/KanbanTaskLaneInfiniteScroll.vue"
      ),
    KanbanTaskLaneItem: () =>
      import("@/components_rms/kanban_infinite_scroll/KanbanTaskLaneItem.vue"),
    KanbanTower: () =>
      import("@/components_rms/kanban_infinite_scroll/KanbanTower.vue"),
    WorkflowKanbanCard: () =>
      import("@/components_rms/workflow/Kanban/WorkflowKanbanCard.vue"),
    WorkflowKanbanCardActions: () =>
      import("@/components_rms/workflow/Kanban/WorkflowKanbanCardActions.vue"),
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      isLoading: false,
      timer: null,
      towers: [],
      towersFiltred: [],
      model: [],
      searchQuery: "",
    };
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  created() {
    this.init();
    // this.loadTowerStart()
  },
  methods: {
    getPermissions(tower) {
      let permission = {
        canView: tower.canView,
        gestor: tower.gestor,
        canSimpleOperate: tower.canSimpleOperate,
        canAdvancedOperate: tower.canAdvancedOperate,
        administrador: tower.administrador,
      };
      return permission;
    },
    onChangeSearchQuery() {
      this.refreshTowers();
    },
    async refreshTowers() {
      for (let taskLane of this.$refs.taskLane) {
        taskLane.rebuildData();
      }
    },
    async autoRefreshTowers() {
      let newSyncTime = this.getDateTimeNow();
      try {
        const response = await this.$apiWorkflow.get(
          `/workflow/cards/paginate/new?processId=${
            this.id
          }&dateLastSync=${this.dateTimeToJsonString(
            this.lastSync
          )}&stringQuery=${this.searchQuery.replace(/#/g, "")}`
        );

        let newItemsList = response.data;
        for (let newItem of newItemsList) {
          let currentTasklane = null;
          let newTasklane = null;

          for (let taskLane of this.$refs.taskLane) {
            for (let card of taskLane.cards) {
              if (card.id == newItem.id) {
                currentTasklane = taskLane;
                break;
              }
            }
            if (taskLane.tower.stageId == newItem.stageId) {
              newTasklane = taskLane;
            }
          }
          if (currentTasklane) {
            currentTasklane.removeCard(newItem);
            currentTasklane.countItems();
          }
          if (newTasklane) {
            if (newItem.active) {
              newTasklane.addCards([newItem]);
              newTasklane.countItems();
            }
          }
        }
        this.lastSync = newSyncTime;

        for (let taskLane of this.$refs.taskLane) {
          if (taskLane.tower.stageType == 2) {
            taskLane.rebuildData();
          }
        }
      } catch (error) {
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          console.log(error);
        }
      }
    },
    async taskLaneCount(ctx, callback) {
      try {
        // if (loading) {
        //   loading(true);
        // }
        const response = await this.$apiWorkflow.get(
          `/workflow/cards/paginate/count?stageId=${ctx.tower.stageId}&stringQuery=${this.searchQuery}`
        );
        callback(response.data);
      } catch (error) {
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          console.log(error);
        }
      } finally {
        // if (loading) {
        //   loading(false);
        // }
      }
    },
    async taskLaneProvider(ctx, callback) {
      try {
        this.lastSync = this.getDateTimeNow();

        // if (loading) {
        //   loading(true);
        // }
        // ctx.searchQuery
        const response = await this.$apiWorkflow.get(
          `/workflow/cards/paginate/list?currentPage=${
            ctx.currentPage
          }&perPage=${ctx.perPage}&stageId=${
            ctx.tower.stageId
          }&stringQuery=${this.searchQuery.replace(/#/g, "")}`
        );
        for (let opt of response.data) {
          if (opt.active) {
            ctx.items.push(opt);
          }
        }
        ctx.hasNextPage = response.data.length >= ctx.perPage;
        callback(ctx);
      } catch (error) {
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          console.log(error);
        }
      } finally {
        // if (loading) {
        //   loading(false);
        // }
      }
    },
    showModal() {
      this.$refs.fillModal.show();
    },
    // showImportModal() {
    //   this.$refs.importModal.show();
    // },
    layoutModal() {
      this.$refs.layoutImport.show();
    },
    init() {
      // console.log(new Date());
      // this.getInitTowersDebug();
      // this.loadTowerStart();

      this.fetchEventsList();
      this.timer = setInterval(
        this.fetchEventsList,
        this.$store.getters.autoRefreshTime
      );
    },
    async fetchEventsList() {
      if (this.isLoading) return;
      // console.log('fetchEventsList');
      this.isLoading = true;
      this.loadTowerStart();

      // this.timer = setInterval(
      //   this.autoRefreshTowers,
      //   this.$store.getters.autoRefreshTime
      // );

      // if (this.towers.length == 0) {
      //   this.loadTowerStart();
      // } /*else {
      //   let newCards = await this.getNewCards();
      //   // this.removeExistingCard(newCards);
      //   // this.addNewCard(newCards);
      //   this.refreshCargosElapsedTime();
      // }*/
    },
    async getNewCards() {
      let dateSearch = this.lastSync;
      this.lastSync = new Date();
      let towers = [];
      await this.$apiWorkflow
        .get("/workflow/lastDate/" + dateSearch.toJSON())
        .then((response) => {
          towers = response.data;
        });
      return towers;
    },
    removeExistingCard(newCards) {
      this.towers.forEach((tower) => {
        for (let i = tower.cards.length - 1; i >= 0; i--) {
          let cardId = tower.cards[i];
          newCards.forEach((newCard) => {
            if (newCard.id == cardId.id) {
              tower.cards.splice(i, 1);
            }
          });
        }
      });
    },
    addNewCard(newCards) {
      this.towers.forEach((tower) => {
        newCards.forEach((newCard) => {
          if (tower.stageId == newCard.stageId) {
            tower.cards.push(newCard);
          }
        });
      });
    },
    refreshCargosElapsedTime() {
      this.towers.forEach((tower) => {
        tower.cards.forEach((card) => {
          // console.log(card)
          card.elapsedTime = this.getElapsedTime(
            new Date(card.lastOccurrenceDate)
          );
        });
      });
    },
    loadTowerStart() {
      this.$apiWorkflow
        .get(`/workflow/getTowers?processId=${this.id}`)
        .then((response) => {
          let model = response.data;
          this.towers = model;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
              this.$refs.danger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          }
        });
    },
    getElapsedTime(startTime) {
      // later record end time
      var endTime = new Date();

      // time difference in ms
      var timeDiff = endTime - startTime;

      // strip the miliseconds
      timeDiff /= 1000;

      // get seconds
      var seconds = Math.round(timeDiff % 60);

      // remove seconds from the date
      timeDiff = Math.floor(timeDiff / 60);

      // get minutes
      var minutes = Math.round(timeDiff % 60);
      var minutesStr = minutes.toString().padStart(2, "0");

      // remove minutes from the date
      timeDiff = Math.floor(timeDiff / 60);

      // get hours
      var hours = Math.round(timeDiff % 24);
      var hoursStr = hours.toString().padStart(2, "0");

      // remove hours from the date
      timeDiff = Math.floor(timeDiff / 24);

      // the rest of timeDiff is number of days
      var days = timeDiff;
      var daysStr = timeDiff.toString().padStart(2, "0");

      var texto = "";
      if (days > 0) {
        texto = daysStr + "d " + hoursStr + "h " + minutesStr + "m";
      } else if (hours == 0 && minutes == 0) {
        texto = "00h 01m";
      } else {
        texto = hoursStr + "h " + minutesStr + "m";
      }
      return texto;
    },
    getInitTowersDebug() {
      this.towers = [
        {
          name: "Não atendido",
          sequenceNumber: 1,
          processName: "Carga",
          stageId: 22,
          canSimpleOperate: false,
          canAdvancedOperate: true,
          gestor: false,
          administrador: true,
          cards: [
            {
              id: 0,
              processId: 21,
              stageId: 22,
              elapsedTime: "20d 03h 07m",
              lastStatusLatitude: 0,
              lastStatusLongitude: 0,
              lastOccurrenceDate: "2022-07-19T04:43:21.366575",
              allowAttachment: true,
              stageName: "Não atendido",
              text: [
                {
                  text: "Tipo de carga: Contrato",
                },
                {
                  text: "Nome do cliente: Teste00",
                },
                {
                  text: "Nome da filial: Teste00",
                },
                {
                  text: "Data de entrega desejada: 20/07/2022",
                },
                {
                  text: "Hora de entrega desejada: ",
                },
                {
                  text: "Data de expiração: 21/07/2022",
                },
                {
                  text: "Estado de origem: Santa Catarina",
                },
                {
                  text: "Cidade de Origem: Jaraguá do Sul",
                },
                {
                  text: "Estado de destino: Santa Catarina",
                },
                {
                  text: "Cidade de destino: Jaraguá do Sul",
                },
                {
                  text: "Data de atendimento / coleta: 21/07/2022",
                },
              ],
            },
            {
              id: 0,
              processId: 24,
              stageId: 22,
              elapsedTime: "18d 22h 59m",
              lastStatusLatitude: -26.4737759,
              lastStatusLongitude: -48.9993527,
              lastOccurrenceDate: "2022-07-20T08:51:20.514146",
              allowAttachment: true,
              stageName: "Não atendido",
              text: [
                {
                  text: "Tipo de carga: Contrato",
                },
                {
                  text: "Nome do cliente: 00.000.000/0000-00",
                },
                {
                  text: "Nome da filial: 00.000.000/0000-00",
                },
                {
                  text: "Data de entrega desejada: 20/07/2022",
                },
                {
                  text: "Hora de entrega desejada: 11:47",
                },
                {
                  text: "Data de expiração: ",
                },
                {
                  text: "Estado de origem: Santa Catarina",
                },
                {
                  text: "Cidade de Origem: Jaraguá do Sul",
                },
                {
                  text: "Estado de destino: Santa Catarina",
                },
                {
                  text: "Cidade de destino: Jaraguá do Sul",
                },
                {
                  text: "Data de atendimento / coleta: 21/07/2022",
                },
                {
                  text: "CPF do motorista: 000.000.000-00",
                },
                {
                  text: "Nome do motorista: 00.000.000/0000-00",
                },
                {
                  text: "Celular do motorista: 00.000.000/0000-00",
                },
                {
                  text: "Placa do veículo: 00.000.000/0000-00",
                },
                {
                  text: "Placa da primeira carreta: 00.000.000/0000-00",
                },
                {
                  text: "Motivo do não atendimento: Cliente cancelou",
                },
              ],
            },
          ],
        },
        {
          name: "Procurando veículo",
          sequenceNumber: 2,
          processName: "Carga",
          stageId: 4,
          canSimpleOperate: false,
          canAdvancedOperate: false,
          gestor: false,
          administrador: true,
          cards: [
            {
              id: 0,
              processId: 23,
              stageId: 4,
              elapsedTime: "20d 02h 04m",
              lastStatusLatitude: 0,
              lastStatusLongitude: 0,
              lastOccurrenceDate: "2022-07-19T05:46:21.10822",
              allowAttachment: true,
              stageName: "Procurando veículo",
              text: [
                {
                  text: "Tipo de carga: Contrato",
                },
                {
                  text: "Nome do cliente: Teste 000",
                },
                {
                  text: "Nome da filial: Teste 000",
                },
                {
                  text: "Data de entrega desejada: 20/07/2022",
                },
                {
                  text: "Hora de entrega desejada: 10:45",
                },
                {
                  text: "Data de expiração: 13/07/2022",
                },
                {
                  text: "Estado de origem: Santa Catarina",
                },
                {
                  text: "Cidade de Origem: Jaraguá do Sul",
                },
                {
                  text: "Estado de destino: Santa Catarina",
                },
                {
                  text: "Cidade de destino: Jaraguá do Sul",
                },
                {
                  text: "Data de atendimento / coleta: 20/07/2022",
                },
                {
                  text: "CPF do motorista: 000.000.000-00",
                },
                {
                  text: "Nome do motorista: Teste 000",
                },
                {
                  text: "Celular do motorista: 47984337817",
                },
                {
                  text: "Placa do veículo: abc 123",
                },
                {
                  text: "Placa da primeira carreta: abc 123",
                },
              ],
            },
            {
              id: 0,
              processId: 26,
              stageId: 4,
              elapsedTime: "18d 01h 55m",
              lastStatusLatitude: -26.4737695,
              lastStatusLongitude: -48.9993608,
              lastOccurrenceDate: "2022-07-21T05:54:59.403069",
              allowAttachment: true,
              stageName: "Procurando veículo",
              text: [
                {
                  text: "Tipo de carga: Contrato",
                },
                {
                  text: "Nome do cliente: 22.222.222/2222-22",
                },
                {
                  text: "Nome da filial: 22.222.222/2222-22",
                },
                {
                  text: "Data de entrega desejada: 21/07/2022",
                },
                {
                  text: "Hora de entrega desejada: 09:54",
                },
                {
                  text: "Data de expiração: 22/07/2022",
                },
                {
                  text: "Estado de origem: Santa Catarina",
                },
                {
                  text: "Cidade de Origem: Jaraguá do Sul",
                },
                {
                  text: "Estado de destino: Santa Catarina",
                },
                {
                  text: "Cidade de destino: Jaraguá do Sul",
                },
                {
                  text: "Data de atendimento / coleta: 22/07/2022",
                },
                {
                  text: "CPF do motorista: 222.222.222-22",
                },
                {
                  text: "Nome do motorista: 222.222.222-22",
                },
                {
                  text: "Celular do motorista: 222.222.222-22",
                },
                {
                  text: "Placa do veículo: 222.222.222-22",
                },
                {
                  text: "Placa da primeira carreta: 222.222.222-22",
                },
              ],
            },
          ],
        },
        {
          name: "Checklist de carregamento",
          sequenceNumber: 3,
          processName: "Carga",
          stageId: 5,
          canSimpleOperate: false,
          canAdvancedOperate: false,
          gestor: false,
          administrador: true,
          cards: [
            {
              id: 0,
              processId: 25,
              stageId: 5,
              elapsedTime: "18d 22h 54m",
              lastStatusLatitude: -26.4737758,
              lastStatusLongitude: -48.9993622,
              lastOccurrenceDate: "2022-07-20T08:55:34.102446",
              allowAttachment: true,
              stageName: "Checklist de carregamento",
              text: [
                {
                  text: "Tipo de carga: Contrato",
                },
                {
                  text: "Nome do cliente: 111.111.111-11",
                },
                {
                  text: "Nome da filial: 111.111.111-11",
                },
                {
                  text: "Data de entrega desejada: 22/07/2022",
                },
                {
                  text: "Hora de entrega desejada: 11:43",
                },
                {
                  text: "Data de expiração: 21/07/2022",
                },
                {
                  text: "Estado de origem: Santa Catarina",
                },
                {
                  text: "Cidade de Origem: Jaraguá do Sul",
                },
                {
                  text: "Estado de destino: Santa Catarina",
                },
                {
                  text: "Cidade de destino: Jaraguá do Sul",
                },
                {
                  text: "Data de atendimento / coleta: 23/07/2022",
                },
                {
                  text: "CPF do motorista: 111.111.111-11",
                },
                {
                  text: "Nome do motorista: 111.111.111-11",
                },
                {
                  text: "Celular do motorista: 111.111.111-11",
                },
                {
                  text: "Placa do veículo: 111.111.111-11",
                },
                {
                  text: "Placa da primeira carreta: 111.111.111-11",
                },
              ],
            },
          ],
        },
        {
          name: "Agendado",
          sequenceNumber: 4,
          processName: "Carga",
          stageId: 6,
          canSimpleOperate: false,
          canAdvancedOperate: false,
          gestor: false,
          administrador: true,
          cards: [],
        },
        {
          name: "Aguardando coleta",
          sequenceNumber: 5,
          processName: "Carga",
          stageId: 7,
          canSimpleOperate: false,
          canAdvancedOperate: false,
          gestor: false,
          administrador: true,
          cards: [],
        },
        {
          name: "Carregando",
          sequenceNumber: 6,
          processName: "Carga",
          stageId: 15,
          canSimpleOperate: false,
          canAdvancedOperate: false,
          gestor: false,
          administrador: true,
          cards: [],
        },
        {
          name: "Reprovado",
          sequenceNumber: 7,
          processName: "Carga",
          stageId: 21,
          canSimpleOperate: false,
          canAdvancedOperate: false,
          gestor: false,
          administrador: true,
          cards: [],
        },
        {
          name: "Aguardando documentos",
          sequenceNumber: 8,
          processName: "Carga",
          stageId: 16,
          canSimpleOperate: false,
          canAdvancedOperate: false,
          gestor: false,
          administrador: true,
          cards: [],
        },
        {
          name: "Em trânsito",
          sequenceNumber: 9,
          processName: "Carga",
          stageId: 17,
          canSimpleOperate: false,
          canAdvancedOperate: false,
          gestor: false,
          administrador: true,
          cards: [],
        },
        {
          name: "Aguardando descarga",
          sequenceNumber: 10,
          processName: "Carga",
          stageId: 18,
          canSimpleOperate: false,
          canAdvancedOperate: false,
          gestor: false,
          administrador: true,
          cards: [],
        },
        {
          name: "Descarregando",
          sequenceNumber: 11,
          processName: "Carga",
          stageId: 19,
          canSimpleOperate: false,
          canAdvancedOperate: false,
          gestor: false,
          administrador: true,
          cards: [],
        },
        {
          name: "Entregue",
          sequenceNumber: 12,
          processName: "Carga",
          stageId: 20,
          canSimpleOperate: false,
          canAdvancedOperate: false,
          gestor: false,
          administrador: true,
          cards: [],
        },
      ];
    },
  },
  watch: {
    id() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.init();
    },
  },
};
</script>
<style scoped>
/* .importButton{
  margin-left: -5px;
} */
#kanban-board {
  height: calc(100vh - 157px);
}
</style>
